import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function AssessmentLevelContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  assessmentLevelId,
  getSingleAssessmentLevel,
  assessmentLevelInfo,
  getOrdinanceRevisionList,
  ordinanceRevisionList,
}) {
  useEffect(() => {
    if (_.isEmpty(assessmentLevelId)) return;
    getSingleAssessmentLevel(assessmentLevelId);
    if (_.isEmpty(ordinanceRevisionList)) getOrdinanceRevisionList();
  }, []);
  useEffect(() => {
    if (_.isEmpty(assessmentLevelId)) return;
    getSingleAssessmentLevel(assessmentLevelId);
    if (_.isEmpty(ordinanceRevisionList)) getOrdinanceRevisionList();
  }, [assessmentLevelId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(assessmentLevelInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">Information</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(assessmentLevelInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(assessmentLevelInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group ">
                        <div className="form-row">
                          <div className="form-input-group col-12 ">
                            <label className="full-label mb-0">Actual Use:</label>
                            <span className="full-input">
                              {_.get(assessmentLevelInfo, 'attributes.actual_use') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 ">
                            <label className="full-label mb-0">Assessment Level:</label>
                            <span className="full-input">
                              {_.get(assessmentLevelInfo, 'attributes.assessment_level') ||
                                '--'}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 ">
                            <label className="full-label mb-0">Ordinance Revision:</label>
                            <span className="full-input">
                              {(ordinanceRevisionList?.find(item => +_.get(item, 'id') === +_.get(assessmentLevelInfo, 'attributes.ordinance_revision_id') || '')?.attributes.name) || '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

AssessmentLevelContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getSingleAssessmentLevel: PropTypes.instanceOf(Function).isRequired,
  assessmentLevelInfo: PropTypes.instanceOf(Object).isRequired,
  assessmentLevelId: PropTypes.string.isRequired,
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionList: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  assessmentLevelInfo: _.get(api, `${c.GET_SINGLE_ASSESSMENT_LEVEL}.item`) || {},
  assessmentLevelId: _.get(match, 'params.assessmentLevelId') || '',
  ordinanceRevisionList: _.get(api, `${c.GET_ORDINANCE_REVISION}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AssessmentLevelContent);
